import React, { useState } from 'react';
import './RulesModal.css';

export default function RulesModal({ rules = [] }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" className="rules-fab" onClick={() => setOpen(true)}>
        Rules
      </button>
      {open && (
        <div className="rules-overlay" onClick={() => setOpen(false)}>
          <div className="rules-card" onClick={(e) => e.stopPropagation()}>
            {rules.map((r, i) => (
              <p key={i}>
                {i + 1}. {r}
              </p>
            ))}
            <button type="button" className="rules-close" onClick={() => setOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
